import { cn } from "@gymflow/helpers";
import { AnimatePresence, motion } from "framer-motion";
import { forwardRef } from "react";
import { createPortal } from "react-dom";

import { usePortalRoutes } from "../../../hooks";
import { HostedPagesFooter } from "./HostedPagesFooter";

export type HostedPagesOverlayProps = {
  isOpen: boolean;
  children: React.ReactNode;
};

const HostedPagesOverlay = forwardRef<
  React.ElementRef<"div">,
  HostedPagesOverlayProps
>(function HostedPagesOverlay({ isOpen, children }, ref) {
  const { isEmbed } = usePortalRoutes();
  return createPortal(
    <AnimatePresence mode="popLayout">
      {isOpen && (
        <motion.div
          key="overlay"
          className={cn(
            "absolute inset-0 h-screen z-[10002] w-full overflow-hidden overflow-y-auto bg-gray-0 dark:bg-gray-950",
            {
              "pb-6": isEmbed,
            },
          )}
          initial={{ opacity: 0, y: 50 }}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.2,
              type: "spring",
              visualDuration: 0.3,
              bounce: 0.4,
            },
          }}
          exit={{ opacity: 0, y: 50 }}
        >
          <div
            ref={ref}
            className={cn(
              "flex h-full max-h-full flex-col items-center w-full",
              {
                "justify-start": isEmbed,
                "justify-between": !isEmbed,
              },
            )}
          >
            {children}
            <HostedPagesFooter />
          </div>
        </motion.div>
      )}
    </AnimatePresence>,

    document.body,
  );
});

export default HostedPagesOverlay;
